package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "th")
val ThStrings = Strings(
    analyzer = "ตัววิเคราะห์",
    appreciationOverview = "ภาพรวมการเพิ่มมูลค่า",
    chartLegendInterest = "ดอกเบี้ย",
    chartLegendPrincipal = "เงินต้น",
    chartXaxisMonths = "เดือน",
    chartYaxisPayment = "การชำระเงิน",
    code = "th",
    costOfCredit = "ต้นทุนสินเชื่อ",
    creditDealAnalyzerDescription = "ป้อนรายละเอียดเงินกู้ของคุณเพื่อรับการวิเคราะห์ข้อตกลงสินเชื่อที่ครอบคลุม ตัววิเคราะห์ของเราประเมินตัวชี้วัดหลักเพื่อช่วยให้คุณเข้าใจต้นทุนที่แท้จริงของเงินกู้และตัดสินใจได้อย่างมีข้อมูล",
    detailsGoodRateLongTerm = "อัตราดอกเบี้ยดีแต่ระยะยาวส่งผลให้ต้นทุนรวมสูง",
    detailsHighApr = "APR สูง ",
    detailsHighInterestCost = "ต้นทุนดอกเบี้ยรวมสูง",
    detailsHighRateShortTerm = "อัตราดอกเบี้ยสูงแต่ระยะสั้นช่วยให้ต้นทุนรวมต่ำ",
    detailsLowApr = "APR ต่ำ ",
    detailsLowInterestCost = "ต้นทุนดอกเบี้ยรวมต่ำ",
    discountsTradeIn = "ส่วนลด / แลกเปลี่ยน",
    displayName = "ไทย",
    distribution = "การกระจาย",
    downPayment = "เงินดาวน์",
    effectiveApr = "APR",
    headerBalance = "ยอดคงเหลือ",
    headerDate = "วันที่",
    headerInterest = "ดอกเบี้ย",
    headerMonth = "#",
    headerPayment = "การชำระเงิน",
    headerPrincipal = "เงินต้น",
    hideDetails = "ซ่อนรายละเอียด",
    interest = "ดอกเบี้ย",
    invalidData = "ข้อมูลไม่ถูกต้อง",
    loanAmountSupportingText = "จำนวนเงินกู้ทั้งหมด รวมถึงค่าใช้จ่ายเพิ่มเติมใดๆ",
    loanDetails = "รายละเอียดเงินกู้",
    paymentSupportingText = "การชำระเงินรายเดือนโดยประมาณของคุณ",
    paymentComposition = "องค์ประกอบการชำระเงิน",
    percentSymbol = "%",
    principal = "เงินต้น",
    ratingBad = "ข้อตกลงแย่",
    ratingExcellent = "ข้อตกลงยอดเยี่ยม",
    ratingFair = "ข้อตกลงยุติธรรม",
    ratingGood = "ข้อตกลงดี",
    ratingPoor = "ข้อตกลงไม่ดี",
    schedule = "กำหนดการ",
    showDetails = "แสดงรายละเอียด",
    summaryBad = "ไม่เอื้ออำนวนอย่างยิ่ง หลีกเลี่ยงหากเป็นไปได้",
    summaryExcellent = "เงื่อนไขทางการเงินที่ยอดเยี่ยม",
    summaryFair = "เงื่อนไขยุติธรรม พิจารณาเจรจาต่อรอง",
    summaryGood = "เงื่อนไขดี มาตรฐานสำหรับตลาด",
    summaryPoor = "เงื่อนไขไม่ดี ต้นทุนหรืออัตราดอกเบี้ยสูง",
    totalPaid = "จ่ายทั้งหมด",
    lockTaxRate = "ล็อคอัตราภาษี",
    unlockTaxRate = "ปลดล็อคอัตราภาษี",
    currencySymbol = "฿",
    currency = "สกุลเงิน",
    totalCreditAmount = "จำนวนสินเชื่อทั้งหมด",
    taxAmount = "จำนวนภาษี/การหักเงิน",
    netAmountDisbursed = "จำนวนเงินสุทธิที่เบิกจ่าย",
    years = "ปี",
    loanTermTotalMonths = "ระยะเวลาเงินกู้ (เดือน)",
    monthlyInstallment = "ค่างวดรายเดือน",
    principalInstallment = "ค่างวดเงินต้น",
    otherFees = "ค่าธรรมเนียมอื่นๆ",
    insuranceCost = "เบี้ยประกัน",
    aprc = "อัตราดอกเบี้ยที่แท้จริงต่อปี (APRC)",
    totalAmountPayable = "จำนวนเงินทั้งหมดที่ต้องชำระ",
    prepaidFeeFixed = "ค่าธรรมเนียมการดำเนินการ (จำนวนคงที่)",
    prepaidFeePercentage = "ค่าธรรมเนียมการดำเนินการ (เปอร์เซ็นต์)",
    months = "เดือน",
    description = "ตัววิเคราะห์นี้ช่วยให้คุณประเมินว่าข้อเสนอเงินกู้เป็นประโยชน์ต่อคุณหรือไม่ แตกต่างจากเครื่องคิดเลขทั่วไป ไม่จำเป็นต้องป้อนอัตราดอกเบี้ย แต่จะคำนวณ APR และต้นทุนรวมของสินเชื่อตามการชำระเงินและค่าธรรมเนียม โดยให้คะแนนข้อตกลงและแผนภูมิโดยละเอียด",
    agree = "ตกลง",
    information = "ข้อมูล",
    errorCalculationOverflow = "APR สูงเกินไป การคำนวณล้น",
    errorTotalPaymentIsLessThanLoanAmount = "จำนวนเงินที่ได้รับน้อยกว่าจำนวนเงินกู้",
    errorDivisionByZero = "หารด้วยศูนย์",
    errorNegativeResult = "ผลลัพธ์เป็นลบ",
    errorRateTooHigh = "อัตราสูงเกินไป",
    errorCalculation = "กรุณาใส่ข้อมูลที่ถูกต้อง",
    close = "ปิด",

    hi = "สวัสดี",
    guest = "ผู้มาเยือน",
    account = "บัญชี",
    signInWithGoogle = "ลงชื่อเข้าใช้ด้วย Google",
    signOut = "ออกจากระบบ",
    settings = "การตั้งค่า",
    about = "เกี่ยวกับ",
    privacyPolicy = "นโยบายความเป็นส่วนตัว",
    termsOfService = "ข้อกำหนดในการให้บริการ",
    language = "ภาษา",

    theme = "ธีม",
    light = "สว่าง",
    dark = "มืด",
    system = "ระบบ",
    toggleExpand = "ขยาย/ย่อ",
)
